import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import { AppCurrencyAutocomplete } from "@components"

export default function CurrencyField() {

	const {
		idCurrency,
		setIdCurrencyInfo,
		error
	} = useReportFormInfo(reportFormData.peek().idCurrency, "idCurrency", object({ idCurrency: string().required("Must provide a currency").min(1, "Must provide a currency") }))

	return <AppCurrencyAutocomplete
		label="Currency code"
		placeholder="Select a Currency"
		value={idCurrency || ""}
		error={error}
		onChange={e => setIdCurrencyInfo(e.target.value)}
	/>
}